import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { ConversationGoalsResponseDataSchema, DataResponse } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof ConversationGoalsResponseDataSchema>>

type Props = {
  conversationId: string
  enabled?: boolean
}

export const conversationGoalsQuery = ({ conversationId, enabled = true }: Props) => {
  return queryOptions({
    queryKey: ["conversationGoals", conversationId],
    queryFn: async () => {
      const { data } = await axios.get<Response>(`/conversations/${conversationId}/goals`)
      return data.data
    },
    enabled,
  })
}
